
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.945 2.32h16.11a.75.75 0 0 1 .555 1.255l-6.165 6.78a.75.75 0 0 0-.195.505v5.309a.75.75 0 0 1-.334.624l-3 2a.75.75 0 0 1-1.166-.624V10.86a.75.75 0 0 0-.195-.504L3.39 3.575a.75.75 0 0 1 .555-1.255z",
  fill: "var(--theme-light,#e2cff7)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.766 22.093h4.472",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.945 2.32h16.11a.75.75 0 0 1 .555 1.255l-6.165 6.78a.75.75 0 0 0-.195.505v5.309a.75.75 0 0 1-.334.624l-3 2a.75.75 0 0 1-1.166-.624V10.86a.75.75 0 0 0-.195-.504L3.39 3.575a.75.75 0 0 1 .555-1.255z\" fill=\"var(--theme-light,#e2cff7)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M9.766 22.093h4.472\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/filter.8c5719984ad27bebc6fbc53662b0e36b.svg"),
        {
          React: SvgFilter,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      